import { render, staticRenderFns } from "./LogoIPM.vue?vue&type=template&id=30057238&scoped=true&"
import script from "./LogoIPM.vue?vue&type=script&lang=js&"
export * from "./LogoIPM.vue?vue&type=script&lang=js&"
import style0 from "./LogoIPM.vue?vue&type=style&index=0&id=30057238&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30057238",
  null
  
)

export default component.exports